import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_IMG = "https://customer-assets.emergentagent.com/job_work-travel-expert/artifacts/9wyed2ow_647C3179-9A0A-4A99-83DA-FA4F3D67B620.png";

export const Seo = ({ title, description, keywords, path = "", image, type = "website", schema, noindex = false }) => {
  const url = `https://worktravelexpert.net${path}`;
  const img = image || DEFAULT_IMG;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Work & Travel Expert" />
      <meta property="og:locale" content="fr_FR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};
